// import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, Clock } from "lucide-react";
import { articles } from "../data/shiftlogArticles";

/**
 * ResourcesArticles
 * Drop-in section for the existing /resources page.
 * Renders the ShiftLog blog articles list inside a self-scoped dark theme
 * (.sl-scope) so it never affects the surrounding light/site styling.
 *
 * Usage in your Resources.jsx page:
 *   import ResourcesArticles from "../components/shiftlog/ResourcesArticles";
 *   ...
 *   <ResourcesArticles />
 *   <h2>Tools & Downloads</h2>
 *   {/* existing SAP Guide + Lean Toolkit content here *\/}
 */
const ResourcesArticles = () => {
  const sorted = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1));

  return (
    <div className="sl-scope" data-testid="shiftlog-resources-articles">
      <section className="sl-hero" data-testid="resources-hero">
        <div className="sl-hero__inner">
          <div className="sl-hero__eyebrow">
            <span className="sl-hero__dot" />
            Resources · Manufacturing Ops
          </div>
          <h2 className="sl-hero__title">
            Field notes on <em>shift handovers,</em>
            <br />
            factory communication <span className="sl-hero__amp">&amp;</span> ShiftLog.
          </h2>
          <p className="sl-hero__lede">
            Practical essays from a decade on the production floor — why
            handovers fail, which tools actually work, and what teams really
            need when the shift changes at 5:30&nbsp;AM.
          </p>
          <div className="sl-hero__meta">
            <span>{sorted.length} articles</span>
            <span className="sl-hero__sep" />
            <span>Updated {sorted[0]?.dateDisplay}</span>
          </div>
        </div>
        <div className="sl-hero__grid" aria-hidden="true" />
      </section>

      <section className="sl-articles" data-testid="articles-section">
        <div className="sl-articles__inner">
          <div className="sl-articles__head">
            <h3 className="sl-articles__title">All articles</h3>
            <div className="sl-articles__count">{sorted.length} published</div>
          </div>

          <div className="sl-articles__grid">
            {sorted.map((a) => (
              <a
                key={a.slug}
                href={`/resources/${a.slug}`}
                className="sl-card"
                data-testid={`article-card-${a.slug}`}
              >
                <div className={`sl-card__media sl-card__media--${a.accent}`}>
                  <div className="sl-card__media-label">
                    <span>{a.category}</span>
                  </div>
                  <div className="sl-card__media-shape" />
                </div>

                <div className="sl-card__body">
                  <div className="sl-card__meta">
                    <span className="sl-card__meta-item">
                      <Calendar size={13} strokeWidth={2.2} />
                      {a.dateDisplay}
                    </span>
                    <span className="sl-card__meta-item">
                      <Clock size={13} strokeWidth={2.2} />
                      {a.readTime}
                    </span>
                  </div>

                  <h4 className="sl-card__title">{a.title}</h4>
                  <p className="sl-card__excerpt">{a.excerpt}</p>

                  <div
                    className="sl-card__cta"
                    data-testid={`read-article-button-${a.slug}`}
                  >
                    Read Article
                    <ArrowUpRight size={16} strokeWidth={2.4} />
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResourcesArticles;
